import { httpClient } from './httpClient';

const base = '/api/catalogo-entregables';

export const listarCatalogoEntregables = () => httpClient.get(base);
export const crearCatalogoEntregable = (payload) => httpClient.post(base, payload);
export const actualizarCatalogoEntregable = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const listarCursosAsignados = (id) => httpClient.get(`${base}/${id}/cursos`);
export const actualizarCursosAsignados = (id, cursoIds) =>
  httpClient.put(`${base}/${id}/cursos`, { curso_ids: cursoIds });

const catalogoEntregablesService = {
  listar: listarCatalogoEntregables,
  crear: crearCatalogoEntregable,
  actualizar: actualizarCatalogoEntregable,
  listarCursosAsignados,
  actualizarCursosAsignados,
};

export default catalogoEntregablesService;
